import { render, staticRenderFns } from "./ReplyButton.vue?vue&type=template&id=25c73366"
import script from "./ReplyButton.vue?vue&type=script&lang=ts"
export * from "./ReplyButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports